// extracted by mini-css-extract-plugin
export default {"tint":"multiRunVoteFelt_tint__Vti24"};